export var MobileDrawerPosition;
(function (MobileDrawerPosition) {
    MobileDrawerPosition["Top"] = "top";
    MobileDrawerPosition["Bottom"] = "bottom";
})(MobileDrawerPosition || (MobileDrawerPosition = {}));
//# sourceMappingURL=types.js.map